<template>
    <transition name="modal-bounce">
        <div class="modal-view" v-if="isShow">
        
            <div class="content w-40">
                <div class="header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        @click="hide"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <p class="title mb-0">民眾通報受理單連結</p>
                </div>
                <div class="body pb-4">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3 mb-xl-3">
                                <label class="form-label">
                                    <span class="me-2">QRCode</span>
                                    <i class="align-middle fas fa-fw fa-cloud-download-alt cursor-pointer"
                                    @click="downloadQRCode"></i>
                                </label>
                                <div ref="qrContainer">
                                    <qrcode-vue 
                                        :value="url"
                                        :size="qrCodeSize"
                                        :render-as="'canvas'"
                                        ref="intakeQrcode"
                                        id="intakeQrcode"
                                    ></qrcode-vue>
                                </div>
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <label class="form-label">
                                    <span>連結</span>
                                    <i class="align-middle ms-2 me-2 fas fa-fw fa-copy cursor-pointer"
                                    @click="copyToClipboard"></i>
                                    <small v-if="copy_alert">已複製到剪貼簿</small>
                                </label>
                                <input class="form-control" type="text" disabled
                                    :value="url"
                                >
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        
        
        </div>
    </transition>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
export default {
    name:'openOutSideCreateIntake',
    props:[],
    data(){
        return {
            isShow:false,
            qrCodeSize: 375, // 初始大小，可以是任何數字
            copy_alert:false,
            url: `${process.env.VUE_APP_QRCODE_BASE_URL}/createIntake`
        }
    },
    components: {
        QrcodeVue
    },
    methods:{
        show(data){
            this.isShow = true
        },
        hide(){
            this.isShow = false
        },
        copyToClipboard(){
            navigator.clipboard.writeText(this.url).then(() => {
                this.$debug('已複製到剪貼簿');
                // 你可以在這裡加入提示，例如顯示通知或改變圖示狀態
                this.copy_alert = true
                setTimeout(()=>{ this.copy_alert = false },1000)
            }).catch(err => {
                console.error('無法複製到剪貼簿:', err);
            });
        },
        updateQRCodeSize() {
        // 計算父元素的寬度，並設置 QR code 的大小
            if (this.$refs.qrContainer) {
                if ( this.$refs.qrContainer.clientWidth > 300 ){
                    this.qrCodeSize = 300;
                    return
                }
                this.qrCodeSize = this.$refs.qrContainer.clientWidth;
            }
        },
        downloadQRCode() {
            console.log('downloadQRCode triggered' , this.$refs.intakeQrcode); // 確認方法是否執行
            const canvas = this.$refs.intakeQrcode.$el; // 直接取得 DOM
            if (canvas && canvas.tagName === 'CANVAS') {
                const link = document.createElement('a');
                link.href = canvas.toDataURL('image/png');
                link.download = 'qrcode.png';
                link.click();
                console.log('Download triggered');
            } else {
                console.error('未找到 canvas 元素');
            }
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateQRCodeSize);
    },
    async mounted(){
        this.updateQRCodeSize()
    },
    async created(){
        
    }
};
</script>
<style scoped>
.w-80 {
    width: 80%;
}

</style>